.headerText {
  font-weight: 500;
  font-size: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  h2 {
    font-weight: 500;
    font-size: 20px;
  }

  @include mobile(1700px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    top: -8px;
  }

  @include themify($themes) {
    color: themed("main-primary");
  }

  .seatsHeader {
    display: flex;
    align-items: center;
    gap: 10px;
    position: absolute;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }

  .badge {
    display: flex;
    align-items: center;
    gap: 8px;
    @include themify($themes) {
      color: themed("main-primary");

      @include dark-mode() {
        background: themed("neutral-secondary");
      }

      @include light-mode() {
        background: #fff;
        border: 1px solid rgba(themed("neutral-secondary"), 0.4);
      }
    }
    padding: 5px 12px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: normal;

    span {
      opacity: 0.75;
    }

    svg {
      width: 16px;
      height: 16px;
      @include themify($themes) {
        color: themed("neutral-primary");
      }
    }
  }
}
